<template>
  <div class="jumbotron">
    <div class="row">
      <h2>My Basic Details</h2>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Legal First Name<span v-if="!getLegalFirstName" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="legalFirstName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': legalFirstNameInvalid}">
        <div class="invalid-feedback">
          Please enter your first name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Last Name<span v-if="!getLastName" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="lastName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': lastNameInvalid}">
        <div class="invalid-feedback">
          Please enter your last name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Email<span v-if="!getEmail" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="email"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': emailInvalid}">
        <div class="invalid-feedback">
          Please enter a valid email
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Cell Number<span v-if="!getCellPhone" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <vue-tel-input v-model="cellPhone"
                       :disabledFetchingCountry="true"
                       class="form-control form-control-md phone-number"
                       v-bind:class="{'is-invalid': cellPhoneInvalid, 'border-red': cellPhoneInvalid}"
                       :onlyCountries="['us']">
        </vue-tel-input>
        <div class="invalid-feedback">
          Please enter a valid cell phone number
        </div>
      </div>
    </div>
    <div class="row">
      <h2>My Current Address</h2>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Street 1</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="street1"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': street1Invalid}">
        <div class="invalid-feedback">
          Please enter your address
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Street 2</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="street2"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': street2Invalid}">
        <div class="invalid-feedback">
          Please enter your address
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">City</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="city"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': cityInvalid}">
        <div class="invalid-feedback">
          Please enter your city of residence
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">State</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="state"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': stateInvalid}">
        <div class="invalid-feedback">
          Please enter your state of residence
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Zip Code</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="zipCode"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': zipCodeInvalid}">
        <div class="invalid-feedback">
          Please enter your Zip Code
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 offset-md-3">
          <img v-for="(image, index) in imageData"
               class="preview-image"
               v-bind:key="index"
               v-bind:src="image"
               v-on:click="removeImage(index)"
               alt="not working"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <b-alert variant="success"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
          Data Saved
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 offset-lg-4">
        <button v-on:click="save" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      imageData: [],
      legalFirstNameInvalid: false,
      lastNameInvalid: false,
      emailInvalid: false,
      cellPhoneInvalid: false,
      street1Invalid: false,
      street2Invalid: false,
      cityInvalid: false,
      stateInvalid: false,
      zipCodeInvalid: false,
      showDismissibleAlert: false
    }
  },
  components: {
    VueTelInput
  },
  methods: {
    ...mapActions('user', [
      'putUserData'
    ]),
    ...mapMutations('user', [
      'updateLegalFirstName',
      'updateLastName',
      'updateEmail',
      'updateCellPhone',
      'updateStreet1',
      'updateStreet2',
      'updateCity',
      'updateState',
      'updateZipCode'
    ]),
    previewImage: function (event) {
      var input = event.target
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData.push(e.target.result)
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    removeImage (index) {
      this.imageData.splice(index, 1)
    },
    async save () {
      this.validate()
      if (this.formInvalid === false) {
        try {
          this.putUserData()
          this.showDismissibleAlert = true
        } catch (error) {
          console.log(error)
          this.showDismissibleAlert = false
        }
      }
    },
    validate () {
      this.formInvalid = false

      if (!this.legalFirstName) {
        this.legalFirstNameInvalid = true
        this.formInvalid = true
      } else {
        this.legalFirstNameInvalid = false
      }

      if (!this.lastName) {
        this.lastNameInvalid = true
        this.formInvalid = true
      } else {
        this.lastNameInvalid = false
      }

      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(this.getEmail)) {
        this.emailInvalid = true
        this.formInvalid = true
      } else {
        this.emailInvalid = false
      }

      var cellPhoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
      if (!cellPhoneRegex.test(this.getCellPhone)) {
        this.cellPhoneInvalid = true
        this.formInvalid = true
      } else {
        this.cellPhoneInvalid = false
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'getLegalFirstName',
      'getLastName',
      'getEmail',
      'getCellPhone',
      'getStreet1',
      'getStreet2',
      'getCity',
      'getState',
      'getZipCode'
    ]),
    legalFirstName: {
      get () {
        return this.getLegalFirstName
      },
      set (value) {
        this.updateLegalFirstName(value)
      }
    },
    lastName: {
      get () {
        return this.getLastName
      },
      set (value) {
        this.updateLastName(value)
      }
    },
    email: {
      get () {
        return this.getEmail
      },
      set (value) {
        this.updateEmail(value)
      }
    },
    cellPhone: {
      get () {
        return this.getCellPhone
      },
      set (value) {
        this.updateCellPhone(value)
      }
    },
    street1: {
      get () {
        return this.getStreet1
      },
      set (value) {
        this.updateStreet1(value)
      }
    },
    street2: {
      get () {
        return this.getStreet2
      },
      set (value) {
        this.updateStreet2(value)
      }
    },
    city: {
      get () {
        return this.getCity
      },
      set (value) {
        this.updateCity(value)
      }
    },
    state: {
      get () {
        return this.getState
      },
      set (value) {
        this.updateState(value)
      }
    },
    zipCode: {
      get () {
        return this.getZipCode
      },
      set (value) {
        this.updateZipCode(value)
      }
    }
  },
  mounted () {
    this.$global.gaEvent('userDetails', 'navigation')
  }
}
</script>

<style scoped>
.phone-number >>> input {
  color: #495057;
}

.border-red {
  border-color: red;
}

.border-red:focus-within {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220,53,69,.25);
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.row {
  margin-bottom: 1rem;
}

.red-text {
  color: red;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.needs-margin-right {
  margin-left: .75rem;
}

.preview-image {
  margin: 0 auto !important;
  max-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/userProfile/profiles/UserDetails.vue